import React from 'react'

import { InfoCard } from '@frame/ui-primitives/info-card'

export function BankInfoCard() {
  return (
    <InfoCard className="bg-moss-200 p-4">
      <p>Bank is best suited for individuals with:</p>
      <ul className="ml-2 mt-1 list-outside list-disc pl-4 text-moss-500">
        {[
          {
            title: 'Multiple employment situations.',
            description: 'Multiple jobs, self-employment, and gig workers.',
          },
          {
            title: 'Government benefits and support.',
            description: 'Unemployment, disability, social security, retirement income, and other government programs.',
          },
          {
            title: 'Additional income sources.',
            description: 'Investments, alimony/child support, and creator/influencer income, etc.',
          },
        ].map((item) => (
          <li className="mb-1 pl-2" key={item.title}>
            <div className="text-moss-700">
              <span className="block font-bold">{item.title}</span>
              <span>{item.description}</span>
            </div>
          </li>
        ))}
      </ul>
    </InfoCard>
  )
}
